"use client";
import Breadcrumb from "../common/Breadcrumb";
import LogingArea from "../common/LoginArea";

const Login = () => {
  return (
    <main>
      <Breadcrumb title="Login" />
      <LogingArea isLoginForm={false} />
    </main>
  );
};

export default Login;
